// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-wrapper[data-v-4df9ac7d]{width:100%;height:100%}[data-v-4df9ac7d] .btn-control.mobile{width:100%;height:100%;display:flex;justify-content:center;align-items:center;position:absolute;top:20px;left:20px;background-color:transparent}[data-v-4df9ac7d] .btn-control .btn-pause rect,[data-v-4df9ac7d] .btn-control .btn-play path{fill:#1c1c1e}[data-v-4df9ac7d] .btn-control.btn-pip{display:none}[data-v-4df9ac7d] .playback-control{text-align:left}", ""]);
// Exports
module.exports = exports;
